import React, { useState } from "react";
import { OVERVIEW, GAPS, gapCellClass } from "../../../../../core/theme/reportTheme";
import { gapTable } from "../../../../../core/data/gaps";
import { CHANNEL_NAMES } from "../../../../../core/data/marketOverviewText";

const SORTS = [["fewest", "Fewest first"], ["most", "Most first"], ["az", "Postcode A–Z"]];

// "Where are the gaps?": postcodes as rows, the top keywords as columns.
// Cell = advertisers in the ads (or listings in the map pack); dashed = none.
export default function GapsPanel({ result, expandButton }) {
  const [measure, setMeasure] = useState("ads");
  const [sort, setSort] = useState("fewest");
  const table = gapTable(result, { measure, sort });
  const rows = table.groups[0].rows;
  const ads = measure === "ads";

  return (
    <div className={`${OVERVIEW.panel} flex-1`}>
      <div className={OVERVIEW.panelHeader}>
        <h3 className={OVERVIEW.panelTitle}>Gaps by postcode</h3>
        <div className="flex items-center gap-2">
          <div className={GAPS.toggle}>
            {[["ads", CHANNEL_NAMES.ppc], ["local", CHANNEL_NAMES.local]].map(([id, label]) => (
              <button key={id} type="button" onClick={() => setMeasure(id)} className={measure === id ? GAPS.toggleActive : GAPS.toggleButton}>{label}</button>
            ))}
          </div>
          {expandButton}
        </div>
      </div>
      <div className={GAPS.summaryRow}>
        <span>
          {ads ? `Advertisers in ${CHANNEL_NAMES.ppc}` : `Listings in ${CHANNEL_NAMES.local}`} ·{" "}
          <span className={GAPS.summaryStrong}>{ads ? "no ads" : "none"} in {table.summary.emptyCells} of {table.summary.cells}</span>
        </span>
        <select className={GAPS.sort} value={sort} onChange={e => setSort(e.target.value)}>
          {SORTS.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
        </select>
      </div>
      <div className={OVERVIEW.panelScroll}>
        <table className="w-full border-separate border-spacing-0 table-fixed">
          <thead>
            <tr>
              <th className={`${GAPS.thFirst} w-20`}>Postcode</th>
              {table.keywords.map(k => <th key={k} className={GAPS.th} title={k}>{k}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map(row => (
              <tr key={row.postcode}>
                <td className={GAPS.rowLabel} title={row.town || undefined}>{row.postcode}</td>
                {row.cells.map(cell => (
                  <td key={cell.keyword} className={GAPS.cell}>
                    <div className={gapCellClass(cell.value, cell.searches)} title={cellTitle(row.postcode, cell, ads)}>
                      {cell.searches === 0 ? "–" : cell.value}
                      {cell.searches > 0 && cell.value === 0 && <span className={GAPS.emptyText}>{ads ? "no ads" : "none"}</span>}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {result.gapSummary.keywordsBySearches.length > table.keywords.length && (
        <div className={OVERVIEW.panelFooter}>Showing the top {table.keywords.length} keywords. Use the Keywords filter to see others.</div>
      )}
    </div>
  );
}

function cellTitle(postcode, cell, ads) {
  if (cell.searches === 0) return `${postcode} · ${cell.keyword}: no completed searches`;
  return `${postcode} · ${cell.keyword}: ${cell.value} ${ads ? `advertisers in ${CHANNEL_NAMES.ppc}` : `listings in ${CHANNEL_NAMES.local}`} across ${cell.searches} searches`;
}
